import React from "react";
import MaskGroup from "../../assets/img/maskgroup.svg";

const MaintenanceBanner = ({
	showMaintenanceBanner
}) => {



	return (
		<>
			{/* Show maintenance banner dynamically between 28 October 12:01 AM and 3 November 11:59 PM */}
			{showMaintenanceBanner && (
				<div className="banner-two d-flex px-2 px-md-0 justify-content-center">
					<img className="image-mask" src={MaskGroup} alt="" />
					<span className="banner-text">
						<b>Maintenance Alert:</b> KonfHub will be unavailable on November 3 from 12:30 AM to 2:00 AM (IST).
					</span>
				</div>
			)}

			<style>{`	
                .banner-two {
                    min-height: 40px;
                    background: #F4F7D6;
					padding-top: 10px;
                }
				.banner-text{
					font-size: 14px;
					font-weight: 500;
					line-height: 22px;
				}
				.image-mask{
				   height: 18px;
				   width: 18px;
				   margin-right: 5px;
				}	
            `}</style>
		</>
	);
};

export default MaintenanceBanner;